import { useDep } from '~/compositions/dependency-container'
import LoggerService from '~/services/LoggerService'

export function useLogger() {
  return useDep(LoggerService)
}
